




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Waves from '../../directives/waves/waves';
// import { Button } from 'element-ui';
@Component({
  name: 'lb-button',
  directives: { Waves }
  // components: {
  //   'el-button': Button
  // }
})
export default class extends Vue {
  @Prop({ default: 'default' }) private type!: string;
  @Prop({ default: 'medium', validator: (value) => ['large', 'medium', 'small', 'mini'].indexOf(value) > -1 }) private size!: string;
  @Prop({ default: '' }) private icon!: string;
  @Prop({ default: 'button' }) private nativeType!: string;
  @Prop({ type: Boolean, default: false }) private loading!: boolean;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ type: Boolean, default: false }) private plain!: boolean;
  @Prop() private width!: string | number;

  private handleClick() {
    if (!this.loading && !this.disabled) {
      this.$emit('click');
    }
  }
  private setBackground() {
    let color = '';
    switch (this.type) {
      case 'default':
        color = '#2e6e75';
        break;
      case 'success':
        color = '#19be6b';
        break;
      case 'warning':
        color = '#ff9900';
        break;
      case 'error':
        color = '#ed4014';
        break;
      case 'text':
        color = 'transparent';
        break;
      default:
        color = '#2e6e75';
    }
    return color;
  }
}
